<template>
  <v-card flat color="transparent">
    <v-card-title class="pa-0 mb-6 d-block">
      <div class="d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-cart-outline</v-icon>
        <h4 class="text-h5 font-weight-black white--text">Compras</h4>
      </div>
      <v-divider dark class="mt-2 opacity-10"></v-divider>
    </v-card-title>

    <v-row v-if="compras && compras.data.length > 0" align="center">
      <v-col cols="12" md="5" class="text-center">
        <div class="position-relative">
          <doughnut-chart :chartdata="compras" :options="chartOptions" />
          <div class="mt-4">
            <div class="caption blue-grey--text text--lighten-3 text-uppercase font-weight-bold">Inversión Total</div>
            <div class="text-h4 font-weight-black primary--text">
              {{ totalGastosCompra | convertPesoArg }}
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="7">
        <v-list v-if="verListadoCompra" color="transparent" class="pa-0" dense>
          <v-list-item 
            v-for="gasto in compras.data" 
            :key="gasto.id"
            class="px-0 border-bottom-subtle"
          >
            <v-list-item-avatar size="10" class="mr-3">
              <v-sheet :color="gasto.color" rounded="circle" height="10" width="10"></v-sheet>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="white--text body-2">
                {{ gasto.name }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action class="white--text font-weight-bold body-2">
              {{ (gasto.total || gasto.total_categoria) | convertPesoArg }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <v-row v-else justify="center" class="py-12">
      <v-col cols="12" class="text-center">
        <v-icon size="64" color="blue-grey darken-3">mdi-cart-off</v-icon>
        <h3 class="text-h6 blue-grey--text text--lighten-2 mt-4 font-weight-medium">
          No hay compras registradas
        </h3>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import DoughnutChart from "@/chartjs/doughnut.chart.vue";

export default {
  name: "ChartComprasPorMes",
  components: { DoughnutChart },
  props: {
    compras: { required: true },
    verListadoCompra: { type: Boolean, default: true }
  },
  data() {
    return {
      chartOptions: {
        cutoutPercentage: 75, // Estilo anillo moderno
        legend: { display: false },
        maintainAspectRatio: false,
      }
    };
  },
  computed: {
    totalGastosCompra() {
      if (!this.compras?.data) return 0;
      return this.compras.data.reduce((acc, obj) => acc + (obj.total || obj.total_categoria || 0), 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.opacity-10 { opacity: 0.1; }
.border-bottom-subtle {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.position-relative {
  position: relative;
}
</style>